import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M10 16v-6a2 2 0 1 1 4 0v6","key":"svg-0"}],["path",{"d":"M10 13h4","key":"svg-1"}]]

/**
 * IconLetterASmall
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItbGV0dGVyLWEtc21hbGwiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTEwIDE2di02YTIgMiAwIDEgMSA0IDB2NiIgLz4KICA8cGF0aCBkPSJNMTAgMTNoNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/letter-a-small
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconLetterASmall = createReactComponent('outline', 'letter-a-small', 'LetterASmall', __iconNode);

export default IconLetterASmall;